"use strict";

require("core-js/modules/es6.regexp.replace");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlEntities = htmlEntities;
exports.sanitizeHtml = exports.uniqueElementId = void 0;

var _sanitizeHtml2 = _interopRequireDefault(require("sanitize-html"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function htmlEntities(str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

var lastUniqueElementId = 0;

var uniqueElementId = function uniqueElementId() {
  return "sbc-el-".concat(lastUniqueElementId++);
};

exports.uniqueElementId = uniqueElementId;

var sanitizeHtml = function sanitizeHtml(content) {
  return (0, _sanitizeHtml2["default"])(content, {
    allowedTags: _sanitizeHtml2["default"].defaults.allowedTags.concat(['img', 'br', 'hr']),
    allowedAttributes: {
      '*': ['href', 'align', 'alt', 'title', 'src', 'srcset', 'center', 'bgcolor', 'style', 'data-*']
    }
  });
};

exports.sanitizeHtml = sanitizeHtml;